import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";

const useColumnDefs = () => {

  
  const companyNameColumn: ColDef = {
    field: "company_name",
    headerName: "Customer Name",
    cellRenderer: (props: any) => {
      return renderNA(props.data.company_name);
    },
  };

  const IndustryNameColumn: ColDef ={
      ...generateColumn("", `industries`),
  
      cellRenderer: (props: any) => {
        return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
      },
      filterValueGetter: (props: any) => {
        return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
      },
      tooltipValueGetter: (props: any) => {
        return renderNA(props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.toString());
      },
      valueGetter: (props: any) => {
        return props.data?.[`industries`]?.map((data: any) => { return data?.industry_name })?.join("#");
      },
    };

  return [
    idColumn,
    companyNameColumn,
    IndustryNameColumn,
    statusColumn,
    { ...actionColumn, width: 195, minWidth: 195 },
  ];
};

export default useColumnDefs;
